import { render, staticRenderFns } from "./BasicForm.vue?vue&type=template&id=222f89aa"
import script from "./BasicForm.vue?vue&type=script&lang=js"
export * from "./BasicForm.vue?vue&type=script&lang=js"
import style0 from "./BasicForm.vue?vue&type=style&index=0&id=222f89aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports